import React from "react";

const TreeCtx = React.createContext({
  setTree: () => {},
});

export default TreeCtx;
